var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionMehNoBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8078 11.3575C22.8078 17.629 17.7237 22.7131 11.4522 22.7131C5.18074 22.7131 0.0966797 17.629 0.0966797 11.3575C0.0966797 5.08601 5.18074 0.00195312 11.4522 0.00195312C17.7237 0.00195312 22.8078 5.08601 22.8078 11.3575Z",
    fill: "url(#paint0_linear_1209_24049)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6149 13.8869C18.7623 13.3312 18.5166 13.7623 19.0724 13.9097L19.2575 13.9588C21.535 14.5629 22.8903 16.9013 22.2855 19.1814C21.6808 21.4615 19.3447 22.8209 17.0673 22.2169L15.1926 21.7197C14.6369 21.5723 14.3058 21.0023 14.4532 20.4466C14.5076 20.2414 14.6197 20.0668 14.7673 19.9357L14.6696 19.9098C14.1139 19.7624 13.9346 19.2326 14.082 18.6769C14.1387 18.463 14.2581 18.2824 14.4151 18.1495C13.9805 17.9345 13.7424 17.4367 13.8715 16.9498C13.9464 16.6674 14.2089 16.5081 14.2245 16.4492C11.887 15.8293 12.0785 15.8801 11.8075 15.3271C11.7436 15.1395 11.7326 14.9317 11.7872 14.7258C11.9346 14.1701 12.5046 13.839 13.0603 13.9864L20.1109 15.8564C20.0477 15.6693 18.5605 14.0921 18.6149 13.8869Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3876 15.9667L21.4425 15.9813C21.4474 16.0294 21.4863 16.1192 21.541 16.2456C21.7517 16.7323 22.1981 17.7634 21.8527 19.0655C21.3138 21.0971 19.2328 22.3074 17.2051 21.7696L15.3281 21.2717C15.0215 21.1904 14.8388 20.8759 14.9201 20.5693C15.0014 20.2629 15.3161 20.0805 15.6225 20.1614L15.6203 20.1608L15.7399 19.7097L14.9592 19.5027C14.6526 19.4214 14.47 19.1069 14.5513 18.8003C14.6325 18.4939 14.9466 18.3113 15.2529 18.3921L15.3733 17.9413L14.7488 17.7756C14.4422 17.6943 14.2595 17.3798 14.3408 17.0732C14.4222 16.7666 14.7366 16.584 15.0432 16.6653L15.8239 16.8724L15.9436 16.4213L12.6644 15.5516C12.3578 15.4703 12.1752 15.1558 12.2565 14.8492C12.3378 14.5426 12.6523 14.3599 12.9589 14.4412L16.2378 15.3109L19.868 16.2737L20.0041 15.7604L18.4631 14.5213C18.2202 14.3173 18.1888 13.955 18.3928 13.7121C18.5969 13.4693 18.9592 13.4378 19.2021 13.6418L20.3314 14.5264C20.7683 14.8935 21.127 15.3794 21.3876 15.9667Z",
    fill: "url(#paint1_linear_1209_24049)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0021 16.2131C21.7902 15.5628 21.4432 14.8632 20.7224 14.2351L19.4909 13.2748C19.0507 12.9049 18.394 12.962 18.0242 13.4022C17.8876 13.5647 17.8093 13.7567 17.7869 13.953L17.7824 13.9492C17.7449 14.2837 17.8701 14.6301 18.1471 14.8629L19.7143 16.1129L19.8795 16.2617L20.0134 15.7569L18.4518 14.5116C18.2089 14.3075 18.1774 13.9452 18.3815 13.7024C18.5855 13.4595 18.9478 13.428 19.1907 13.6321L20.4222 14.5924C20.9669 15.1782 20.9669 15.1782 21.4631 16.1414L22.0021 16.2131Z",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32715 13.4375L16.2642 11.7003",
    stroke: "black",
    strokeWidth: 0.35,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85082 7.69426C7.97917 8.35453 7.72637 8.95914 7.2862 9.04471C6.84602 9.13027 6.38514 8.66438 6.2568 8.00411C6.12846 7.34385 6.38125 6.73923 6.82143 6.65367C7.2616 6.56811 7.72248 7.034 7.85082 7.69426Z",
    fill: "#262626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5187 5.09858C12.5187 5.09858 13.2587 4.67138 13.5348 4.51198C14.0429 4.21864 14.4436 4.32595 14.4436 4.32595",
    stroke: "#262626",
    strokeWidth: 0.35,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29054 5.17339C5.29054 5.17339 5.45309 4.77194 6.01725 4.53294C6.58141 4.29394 6.98296 4.45653 6.98296 4.45653",
    stroke: "#262626",
    strokeWidth: 0.35,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8567 6.23528C14.985 6.89555 14.7322 7.50016 14.2921 7.58572C13.8519 7.67128 13.391 7.20539 13.2627 6.54513C13.1343 5.88486 13.3871 5.28025 13.8273 5.19469C14.2675 5.10912 14.7283 5.57501 14.8567 6.23528Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1209_24049",
    x1: 0.0966797,
    y1: 0.00195312,
    x2: 23.7881,
    y2: 1.07531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1209_24049",
    x1: 15.999,
    y1: 10.6104,
    x2: 23.6591,
    y2: 18.3511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionMehNoBg);
export default __webpack_public_path__ + "static/media/reaction_meh_no-bg.23b6be223d304a76c051b21a87bb17ba.svg";
export { ForwardRef as ReactComponent };